import { object, string, ref } from "yup";

export const getValidationSchema = (t) => object().shape({
  password: string()
    .required(t("signup.validation.passwordRequired"))
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/,
      t("signup.validation.passwordRules")
    ),
    mobileNumber:  string()
    .required(t("signup.validation.mobileRequired")),
    confirmMobileNumber: string()
    .required(t("signup.validation.confirmMobileRequired"))
    .oneOf([ref('mobileNumber')], t("signup.validation.mobileMustMatch")),
    email: string()
    .required(t("signup.validation.emailRequired")),
    firstName: string()
    .required(t("signup.validation.firstNameRequired")),
    lastName: string()
    .required(t("signup.validation.lastNameRequired")),
    confirmPassword: string()
    .required(t("signup.validation.passwordsMustMatch"))
    .oneOf([ref('password')], t("signup.validation.passwordsMustMatch"))
});

export const getSignupInputs = (t) => [
  {
    name: "email",
    label: t("signup.fields.emailLabel"),
    type: "email",
    placeholder: t("signup.fields.emailPlaceholder"),
  },
  {
    name: "firstName",
    label: t("signup.fields.firstNameLabel"),
    type: "text",
    placeholder: t("signup.fields.firstNamePlaceholder"),
  },
  {
    name: "lastName",
    label: t("signup.fields.lastNameLabel"),
    type: "text",
    placeholder: t("signup.fields.lastNamePlaceholder"),
  },
  {
    name: "mobileNumber",
    label: t("signup.fields.mobileLabel"),
    type: "text",
    placeholder: t("signup.fields.mobilePlaceholder"),
  },
  {
    name: "confirmMobileNumber",
    label: t("signup.fields.confirmMobileLabel"),
    type: "text",
    placeholder: t("signup.fields.confirmMobilePlaceholder"),
  },
  {
    name: "password",
    label: t("signup.fields.passwordLabel"),
    type: "password",
    placeholder: t("signup.fields.passwordPlaceholder"),
  },
  {
    name: "confirmPassword",
    label: t("signup.fields.confirmPasswordLabel"),
    type: "password",
    placeholder: t("signup.fields.confirmPasswordPlaceholder"),
  }
];
